import { Card, Typography } from "@mui/material";
import React, { Fragment } from "react";
import { CollabRequests } from "../adminHomePage/CollabRequests";

const AdminCollabRequestsPage = () => {
  return (
    <Fragment>
      <Typography variant="h5" fontWeight={700} color="primary.main" mb={1.5}>Collab Requests</Typography>
      <Card sx={{ height: "100%", overflowY: "auto" }}>
        <CollabRequests
          title={'Collab Requests'}
          subTitle={'View and manage all COLLAB requests.'}
          showHeader={false}
          hideFooter={false}
          viewOnly={true}
          additionalProps={{
            per_page: 10
          }}
        />
      </Card>
    </Fragment>
  );
}

export default AdminCollabRequestsPage;